export const publicConfigActionTypes = {
    FETCH_PUBLIC_CONFIG: 'CONFIG/FETCH_PUBLIC_CONFIG',
    FETCH_PUBLIC_CONFIG_SUCCESS: 'CONFIG/FETCH_PUBLIC_CONFIG_SUCCESS',
    FETCH_PUBLIC_CONFIG_FAILURE: 'CONFIG/FETCH_PUBLIC_CONFIG_FAILURE'
}
